<div class="button-container">
    <div class="selector">
        <ng-container *ngIf="item.selected">
            <div class="rectangle-selector">

            </div>
        </ng-container>
    </div>

    <div class="icon">
        <ng-container *ngIf="!!item.icon">
            <img [src]="'apps/restaurant/src/assets/side-navbar-' + item.icon + (item.selected ? '-selected' : '') + '.svg'"/>
        </ng-container>
    </div>

    <div class="text" [ngClass]="{'selected': item.selected}">
        {{ item.key | translate }}
    </div>

</div>